const changeWindowModalContent = (modalData, modalId, closeBtnReload = false) => {
    let modal = $(`#${modalId}`);
    if (modalData.header !== undefined && modalData.header.length > 0) {
        if (modal.find('.window-head').length > 0) {
            let head = modal.find('.window-head');
            if (modalData.keepCloseBtn) {
                head.children().each(function () {
                    if (!$(this).attr('class') || !$(this).attr('class').includes('window-close')) {
                        $(this).html('');
                    }else if(closeBtnReload && $(this).attr('class') && $(this).attr('class').includes('window-close')){
                        $(this).attr('onclick', "window.location.reload();");
                    }
                });

                if (modal.find('.window-close').length > 0) {
                    head.find('.window-close').before(modalData.header)
                } else {
                    head.html(modalData.header)
                }

            } else {
                head.html(modalData.header);
            }
        } else {
            modal.prepend(`<div class="window-head">${modalData.header}</div>`);
        }
    }

    if (modalData.body !== undefined && modalData.body.length > 0) {
        if (modal.find('.window-body').length > 0) {
            modal.find('.window-body').html(modalData.body)
        } else {
            if (modal.find('.window-head').length > 0) {
                modal.find('.window-head').append(`<div class="window-body">${modalData.body}</div>`);
            } else {
                modal.append(`<div class="window-body">${modalData.body}</div>`);
            }
        }
    }

    if (modalData.footer !== undefined && modalData.footer.length > 0) {
        if (modal.find('.window-footer').length > 0) {
            modal.find('.window-footer').html(modalData.footer);
        } else {
            modal.find('.window-body').append(`<div class="window-footer">${modalData.footer}</div>`);
        }
    }
};

module.exports.changeWindowModalContent = changeWindowModalContent;
